import React from 'react';
import { withRouter } from 'react-router';
import styled, { keyframes } from 'styled-components';
import withStore from 'with-store';
import oh from 'output-helpers';
import userInputs from 'user-inputs';

import Navbar from '../base/Navbar';
import LocalSpinner from '../base/LocalSpinner';
import InformationCard from '../base/InformationCard';
import Notifications from '../../notifications';
import api_helpers from '../../helpers/api_helpers.js';
import Gallery from '../base/Gallery';

const EntityCategory = {
    INVENTORY: 0,
    PHOTOS: 1,
    ORDERS: 2,
    HISTORY: 3,
};

const OrderStateIndex = {
    published: 0,
    assigned: 1,
    completed: 2,
    approved: 3,
};

class EntityView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected_category: EntityCategory.INVENTORY,
            hide_me: false,
            editing: false,
            current_entity_id: null,
            entity_last_modified: 0,
            entity_changeset: {},
            photos: null,
            photos_fetched: false,
            delete_mode: false,
        };

        const anim_slide_in = keyframes`
            from {
                transform: translateX(100%);
            }
            to {
                transform: none;
            }
        `;

        const anim_slide_out = keyframes`
            from {
                transform: none;
            }
            to {
                transform: translateX(100%);
            }
        `;

        const anim_overlay = keyframes`
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        `;

        const anim_overlay_hide = keyframes`
            from {
                opacity: 1;
            }
            to {
                opacity: 0;
            }
        `;

        this.container = styled.div`
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 9;
            pointer-events: none;
            &.hide_me {
                .entity_view_overlay {
                    animation: ${anim_overlay_hide} 0.3s 0.1s both;
                }
                .entity_view {
                    animation: ${anim_slide_out} 0.3s both;
                }
            }
            .entity_view_overlay {
                pointer-events: all;
                animation: ${anim_overlay} 0.3s both;
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.2);
                transition: background-color 0.4s;
                &.editing {
                    cursor: not-allowed;
                    background-color: rgba(0, 0, 0, 0.6);
                }
            }
            .entity_view {
                pointer-events: all;
                pointer-events: all;
                border-left: 2px solid ${props => props.theme.colors.dark[1]};
                animation: ${anim_slide_in} 0.6s 0.2s both;
                width: 40%;
                background-color: ${props => props.theme.colors.background};
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
            }
            .entity_body {
                padding: 12px;
                overflow: auto;
                position: absolute;
                left: 0;
                right: 0;
                bottom: 0;
                top: ${props => props.theme.sizes.sub_navbar.height * 2}px;
                &.no_padding {
                    padding: 0;
                }
                .information_card {
                    border: none;
                    border-radius: 0;
                }
            }
            .task {
                display: inline-block;
                margin: 0 20px 20px 0;
                background-color: #fff;
                border-radius: 4px;
                border: 1px solid ${props => props.theme.colors.border};
                width: 280px;
                .task_head {
                    padding: 8px 12px;
                    .task_title,
                    .task_action {
                        display: inline-block;
                        vertical-align: middle;
                    }
                    .task_title {
                        font-size: 18px;
                        font-weight: bold;
                        width: 85%;
                    }
                    .task_action {
                        width: 15%;
                        text-align: right;
                        svg {
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
                .task_body {
                    padding: 8px 12px 20px;
                    .task_description {
                        font-size: 14px;
                        opacity: 0.6;
                    }
                }
                .task_list {
                    border-top: 1px solid ${props => props.theme.colors.border};
                    ul {
                        li {
                            border-bottom: 1px solid
                                ${props => props.theme.colors.border};
                            &:last-child {
                                border-radius: 0 0 4px 4px;
                                border-bottom: 0;
                            }
                        }
                    }
                }
            }
            .order_panel {
                margin: 0;
                background-color: #fff;
                transition: all 0.3s;
                .order_panel_title {
                    border-bottom: 1px solid
                        ${props => props.theme.colors.border};
                    cursor: pointer;
                    font-size: 16px;
                    font-weight: bold;
                    padding: 20px;
                    overflow: auto;
                    position: relative;
                    p {
                        display: inline-block;
                    }
                    .order_progress {
                        background-color: ${props => props.theme.colors.border};
                        position: absolute;
                        right: 0px;
                        bottom: 0px;
                        left: 0px;
                        height: 4px;
                        .order_progress_bar {
                            background-color: ${props =>
                                props.theme.colors.blue[2]};
                            position: absolute;
                            bottom: 0px;
                            left: 0px;
                            height: 4px;
                        }
                    }

                    &:hover {
                        background-color: ${props => props.theme.colors.border};
                    }
                }
            }
        `;

        this.state_label = styled.div`
            position: absolute;
            right: 20px;
            top: 15px;
            border-radius: 4px;
            color: #fff;
            padding: 4px 8px;
            background-color: ${props =>
                props.theme.colors.states[props.state]
                    ? props.theme.colors.states[props.state]
                    : 'gray'};
        `;
        this.tags_label = styled.div`
            position: absolute;
            right: 120px;
            top: 15px;
            border-radius: 4px;
            color: #fff;
            padding: 4px 8px;
            background-color: ${props =>
                props.theme.colors.states[props.state]
                    ? props.theme.colors.states[props.state]
                    : 'gray'};
        `;
    }

    static getDerivedStateFromProps(next_props, current_state) {
        let next_state = Object.assign({}, current_state);

        let selected_entity = next_props.se.getSelectedEntity();
        if (selected_entity !== null) {
            selected_entity = next_props.store.entity.by_id[selected_entity.id];
        }

        if (!selected_entity) {
            next_state.editing = false;
            next_state.current_entity_id = null;
            next_state.entity_changeset = {};
            next_state.entity_last_modified = 0;
            return next_state;
        }

        if (selected_entity.id !== current_state.current_entity_id) {
            next_state.editing = false;
            next_state.entity_changeset = Object.assign(
                {},
                selected_entity.data,
            );
            next_state.current_entity_id = selected_entity.id;
            next_state.entity_last_modified = selected_entity.last_modified;
        } else if (
            selected_entity.last_modified !== current_state.entity_last_modified
        ) {
            next_state.editing = false;
            next_state.entity_changeset = Object.assign(
                {},
                selected_entity.data,
            );
            next_state.entity_last_modified = selected_entity.last_modified;
        }

        return next_state;
    }

    componentDidMount() {
        this.fileSelector = buildFileSelector();
        this.fileSelector.onchange = this.handleFileUploadSubmit.bind(this);
        let closePromptAndWarn = event => {
            if (this.state.editing) {
                let selected_entity = this.props.se.getSelectedEntity();
                if (selected_entity === null) {
                    return;
                }

                if (
                    selected_entity.data['meta.id'] === event.data.id &&
                    this.state.editing
                ) {
                    if (this.props.userPrompt.isOpen()) {
                        this.props.userPrompt.cancel();
                    }
                    this.props.userPrompt.alert({
                        props: {
                            title: oh.translate('concurrent_modification'),
                            message: oh.translate(
                                'concurrent_modification_desc',
                            ),
                        },
                    });
                }
            }
        };
        Notifications.addEventInspector(this, 'entity_updated', event => {
            closePromptAndWarn(event);
        });
        Notifications.addEventInspector(this, 'entity_deleted', event => {
            closePromptAndWarn(event);
        });
    }

    componentWillUnmount() {
        Notifications.clearEventInspectors(this);
    }

    triggerPropPrompt(prop) {
        let inputs = [];
        if (prop.type === 'string') {
            inputs.push({
                type: 'text',
                key: 'new_value',
                default_value:
                    this.state.entity_changeset.hasOwnProperty(prop.key) &&
                    this.state.entity_changeset[prop.key] !== null
                        ? this.state.entity_changeset[prop.key]
                        : '',
            });
        } else if (prop.type === 'entity') {
            inputs.push({
                type: 'text',
                key: 'new_value',
                default_value:
                    this.state.entity_changeset.hasOwnProperty(prop.key) &&
                    this.state.entity_changeset[prop.key] !== null
                        ? decodeURIComponent(
                              this.state.entity_changeset[prop.key]
                                  .split('/')
                                  .pop(),
                          )
                        : '',
            });
        } else if (prop.type === 'boolean') {
            inputs.push({
                type: 'tri_state',
                key: 'new_value',
                options: [
                    { value: false, label: oh.translate('no') },
                    { value: null, label: oh.translate('unknown') },
                    { value: true, label: oh.translate('yes') },
                ],
                default_value: this.state.entity_changeset.hasOwnProperty(
                    prop.key,
                )
                    ? this.state.entity_changeset[prop.key]
                    : null,
            });
        } else if (prop.type === 'enum') {
            inputs.push({
                type: 'select',
                key: 'new_value',
                options: prop.alternatives.map(opt => {
                    return { value: opt, label: opt };
                }),
                default_value:
                    this.state.entity_changeset.hasOwnProperty(prop.key) &&
                    prop.alternatives.indexOf(
                        this.state.entity_changeset[prop.key],
                    ) !== -1
                        ? this.state.entity_changeset[prop.key]
                        : prop.alternatives[0],
            });
        } else if (prop.type === 'number') {
            inputs.push({
                type: 'text',
                key: 'new_value',
                default_value:
                    this.state.entity_changeset.hasOwnProperty(prop.key) &&
                    this.state.entity_changeset[prop.key] !== null
                        ? this.state.entity_changeset[prop.key].toString()
                        : '',
            });
        } else {
            throw new Error(
                'Unable to render property of unsupported type: ' + prop.type,
            );
        }

        this.props.userPrompt.confirm(
            {
                props: {
                    title: prop.name,
                },
                inputs: inputs,
            },
            values => {
                let update = {};
                if (prop.type === 'entity') {
                    update[prop.key] =
                        'entity://misc/' + encodeURIComponent(values.new_value);
                } else if (prop.type === 'number') {
                    update[prop.key] = parseInt(values.new_value, 10);
                } else {
                    update[prop.key] = values.new_value;
                }
                this.setState({
                    entity_changeset: Object.assign(
                        {},
                        this.state.entity_changeset,
                        update,
                    ),
                });
            },
        );
        this.props.userPrompt.setTag('entity');
    }

    renderEntityBody(orders, tasks) {
        if (this.state.selected_category === EntityCategory.INVENTORY) {
            return this.renderInventoryTab();
        }
        if (this.state.selected_category === EntityCategory.ORDERS) {
            return this.renderOrderTab(tasks, orders);
        }
        if (this.state.selected_category === EntityCategory.PHOTOS) {
            return this.renderPhotosTab();
        }
    }
    renderPhotosTab() {
        let buttons = [
            {
                label: oh.translate('upload'),
                color: 'dark',
                onClick: e => {
                    e.preventDefault();
                    this.fileSelector.click();
                },
            },
            {
                label: oh.translate('delete'),
                color: 'red',
                onClick: e => {
                    e.preventDefault();
                    this.setState({ delete_mode: !this.state.delete_mode });
                },
            },
        ];

        if (this.state.delete_mode) {
            buttons = [
                {
                    label: oh.translate('back'),
                    color: 'green',
                    onClick: e => {
                        e.preventDefault();
                        this.setState({ delete_mode: !this.state.delete_mode });
                    },
                },
            ];
        }

        const this_entity = this.props.se.getSelectedEntity();
        if (!this.state.photos || !this.state.photos_fetched) {
            api_helpers.fetchPhotos(this_entity).then(fetched_photos =>
                this.setState({
                    photos: fetched_photos,
                    photos_fetched: true,
                }),
            );
        }
        return (
            <div className="entity_body no_padding">
                <InformationCard
                    title={oh.translate('photos')}
                    title_buttons={buttons}
                    editing={this.state.editing}
                    items={[]}
                />
                {this.state.photos && this.state.photos_fetched ? (
                    <Gallery
                        images={this.state.photos}
                        delete_mode={this.state.delete_mode}
                        onDelete={
                            this.state.delete_mode
                                ? this.deletePhoto.bind(this)
                                : () => {}
                        }
                    />
                ) : (
                    <LocalSpinner />
                )}
            </div>
        );
    }
    deletePhoto(photo_id) {
        const confirm_res = window.confirm(
            oh.translate('do_you_want_to_delete_this_picture'),
        );
        if (confirm_res) {
            const this_entity = this.props.se.getSelectedEntity();
            const updated_entity = { ...this_entity };
            const photos = JSON.parse(updated_entity.data['meta.photos']);
            updated_entity.data['meta.photos'] = JSON.stringify(
                photos.filter(photo => photo !== photo_id),
            );
            const filtered_photos = this.state.photos.filter(
                photo => photo.id !== photo_id,
            );
            return api_helpers
                .updateEntity('vehicles', updated_entity)
                .then(updated_entity => {
                    withStore.actions.entity.setEntity(
                        'vehicles',
                        updated_entity,
                    );
                    return null;
                })
                .then(() =>
                    this.setState({
                        photos_fetched: false,
                        delete_mode: false,
                        photos: filtered_photos,
                    }),
                );
        }
    }
    renderInventoryTab() {
        let schema = this.props.store.entity.schema.vehicles;
        const information_items = schema.properties
            .filter(prop => prop.key !== 'meta.photos')
            .map(prop => {
                let language = window.sso.getJWT().getClaim('lang');
                let name = '';
                if (prop.key.startsWith('meta.')) {
                    name = prop.name = schema.translations[language][prop.key];
                } else {
                    name = prop.name;
                }

                let value =
                    !this.state.entity_changeset.hasOwnProperty(prop.key) ||
                    this.state.entity_changeset[prop.key] === null
                        ? null
                        : this.state.entity_changeset[prop.key];
                let display_value = null;
                if (prop.type === 'boolean') {
                    display_value =
                        value === null
                            ? ''
                            : value
                            ? oh.translate('yes')
                            : oh.translate('no');
                } else if (prop.type === 'entity') {
                    display_value =
                        value === null
                            ? ''
                            : decodeURIComponent(value.split('/').pop());
                } else {
                    display_value = value === null ? '' : value;
                }

                let modifiable = !!(this.state.editing && prop.modifiable);

                let ret = {
                    label: name,
                    data: display_value,
                    modifiable: modifiable,
                };

                if (modifiable) {
                    ret.onClick = () => {
                        return this.triggerPropPrompt(prop, value);
                    };
                }

                return ret;
            });

        let buttons = [];
        if (this.state.editing) {
            buttons = [
                {
                    label: oh.translate('cancel'),
                    color: 'red',
                    onClick: () => {
                        let selected_entity = this.props.se.getSelectedEntity();
                        let entity_changeset = Object.assign(
                            {},
                            selected_entity.data,
                        );
                        this.setState({
                            editing: false,
                            entity_changeset: entity_changeset,
                        });
                    },
                },
                {
                    label: oh.translate('save'),
                    color: 'green',
                    onClick: () => {
                        withStore.actions.spinner.add();
                        Promise.resolve()
                            .then(() => {
                                let selected_entity = this.props.se.getSelectedEntity();
                                let existing_entity = this.props.store.entity
                                    .by_id[selected_entity.id];

                                let altered_entity = Object.assign(
                                    {},
                                    existing_entity,
                                );
                                altered_entity.data = Object.assign(
                                    {},
                                    altered_entity.data,
                                    this.state.entity_changeset,
                                );

                                return api_helpers
                                    .updateEntity('vehicles', altered_entity)
                                    .then(updated_entity => {
                                        withStore.actions.entity.setEntity(
                                            'vehicles',
                                            updated_entity,
                                        );
                                        return null;
                                    });
                            })
                            .finally(() => {
                                this.setState({ editing: false });
                                withStore.actions.spinner.remove();
                            });
                    },
                },
            ];
        } else {
            buttons = [
                {
                    label: oh.translate('edit'),
                    color: 'dark',
                    onClick: () => {
                        let selected_entity = this.props.se.getSelectedEntity();
                        let entity_changeset = Object.assign(
                            {},
                            selected_entity.data,
                        );
                        this.setState({
                            editing: true,
                            entity_changeset: entity_changeset,
                        });
                    },
                },
            ];
        }

        return (
            <div className="entity_body no_padding">
                <InformationCard
                    title={oh.translate('inventory')}
                    title_buttons={buttons}
                    editing={this.state.editing}
                    items={information_items}
                />
            </div>
        );
    }
    renderOrderTab(tasks, orders) {
        const tag_names = tasks
            .map(task => task.tags)
            .flat(2)
            .map(tag => tag.name);
        return (
            <div>
                <div className="entity_body no_padding">
                    {orders.map((order, i) => {
                        return (
                            <div key={i} className={`order_panel`}>
                                <div
                                    className="order_panel_title"
                                    onClick={() => {
                                        this.props.se.setSelectedOrder(
                                            order.id,
                                        );
                                    }}
                                >
                                    <p>
                                        {oh.translate('order') +
                                            ' #' +
                                            order.id}
                                    </p>

                                    {tag_names.length > 0 && (
                                        <this.tags_label
                                            state={tag_names
                                                .slice(0, 2)
                                                .toString()}
                                        >
                                            {tag_names.slice(0, 2).toString()}
                                        </this.tags_label>
                                    )}
                                    <this.state_label state={order.state}>
                                        {oh.translate(
                                            'singular_' + order.state,
                                        )}
                                    </this.state_label>
                                </div>
                            </div>
                        );
                    })}
                </div>
                {this.props.store.order.fetched === false && <LocalSpinner />}
            </div>
        );
    }
    handleFileUploadSubmit() {
        api_helpers
            .uploadPhotoFiles(
                this.state.current_entity_id,
                this.fileSelector.files,
            )
            .then(file_ids => {
                const this_entity = this.props.se.getSelectedEntity();
                const updated_entity = { ...this_entity };
                const parsed_photos =
                    updated_entity.data['meta.photos'] !== ''
                        ? JSON.parse(updated_entity.data['meta.photos'])
                        : [];
                const photo_metas =
                    updated_entity.data['meta.photos'] &&
                    Array.isArray(parsed_photos)
                        ? parsed_photos
                        : [];
                file_ids.forEach(file_id => {
                    if (
                        photo_metas.findIndex(photo => photo === file_id) === -1
                    ) {
                        photo_metas.push(file_id);
                    }
                });
                updated_entity.data['meta.photos'] = JSON.stringify(
                    photo_metas,
                );
                return api_helpers
                    .updateEntity('vehicles', updated_entity)
                    .then(updated_entity => {
                        withStore.actions.entity.setEntity(
                            'vehicles',
                            updated_entity,
                        );
                        return null;
                    })
                    .then(() => this.setState({ photos_fetched: false }));
            });
    }
    triggerCloseView() {
        console.log('closing entityview');
        this.setState({
            hide_me: true,
            selected_category: EntityCategory.INVENTORY,
            photos: null,
            photos_fetched: false,
        });
        setTimeout(() => {
            this.props.se.setSelectedEntity(null);
            this.setState({
                hide_me: false,
                selected_category: EntityCategory.INVENTORY,
            });
        }, 500);
    }

    render() {
        const this_entity = this.props.se.getSelectedEntity();
        let is_order_open = this.props.se.getSelectedOrder();

        if (this_entity === null) {
            return null;
        }

        const tasks = this.props.se.getTasksFromEntityRef(this_entity.id);
        if (tasks === null) {
            return (
                <this.container
                    className={`${this.state.hide_me ? 'hide_me' : ''}`}
                >
                    <div
                        className="entity_view_overlay"
                        onClick={() => {
                            this.triggerCloseView();
                        }}
                    />
                    <div className="entity_view">
                        <LocalSpinner />
                    </div>
                </this.container>
            );
        }

        const distinct_order_ids = tasks.reduce((a, c) => {
            if (a.findIndex(x => x === c.order_id) === -1) {
                a.push(c.order_id);
            }
            return a;
        }, []);
        const orders = this.props.se.getOrdersFromIds(distinct_order_ids);
        orders.sort((a, b) => {
            let ret = OrderStateIndex[a.state] - OrderStateIndex[b.state];
            if (ret === 0) {
                ret = a.id - b.id;
            }
            return ret;
        });
        const categories = [
            {
                name: 'inventory',
                onClick: () => {
                    this.setState({
                        selected_category: EntityCategory.INVENTORY,
                    });
                },
            },
            {
                name: 'photos',
                onClick: () => {
                    this.setState({
                        selected_category: EntityCategory.PHOTOS,
                    });
                },
            },
            {
                name: 'orders',
                onClick: () => {
                    this.setState({ selected_category: EntityCategory.ORDERS });
                },
            },
        ];

        let title = this_entity.name;
        let subtitle = '';
        let v_num = this_entity.data['meta.vehicle_number'];
        if (v_num !== null) {
            subtitle += v_num;
        }
        let v_depot = this_entity.data['meta.depot'];
        if (typeof v_depot === 'string' && v_depot.length > 0) {
            subtitle += ' @ ' + v_depot;
        }
        return (
            <this.container
                className={`${this.state.hide_me ? 'hide_me' : ''}`}
            >
                {is_order_open ? null : (
                    <div
                        className={`entity_view_overlay ${
                            this.state.editing ? 'editing' : ''
                        }`}
                        onClick={() => {
                            this.triggerCloseView();
                        }}
                    />
                )}

                <div className="entity_view">
                    {this.state.editing ? (
                        <div>
                            <Navbar
                                bigTitle={title}
                                subtitle={oh.translate('editing')}
                            />
                            <Navbar />
                        </div>
                    ) : (
                        <div>
                            <Navbar
                                light
                                bigTitle={title}
                                subtitle={subtitle}
                                icon={'entity'}
                                close={() => {
                                    this.triggerCloseView();
                                }}
                            />
                            <Navbar
                                light
                                categories_with_message_count={categories}
                                border
                                selected_category={this.state.selected_category}
                            />
                        </div>
                    )}
                    {this.renderEntityBody(orders, tasks)}
                </div>
            </this.container>
        );
    }
}

function buildFileSelector() {
    const fileSelector = document.createElement('input');
    fileSelector.id = 'file_input';
    fileSelector.setAttribute('type', 'file');
    fileSelector.setAttribute('multiple', 'multiple');
    fileSelector.setAttribute('accept', 'image/*');
    return fileSelector;
}
export default withRouter(userInputs(withStore(EntityView)));



// WEBPACK FOOTER //
// ./src/components/views/EntityView.jsx